import { createFileRoute } from '@tanstack/react-router'
import { MembersPage } from '@/features/account/pages/members-page'

export interface MembersSearch {
  /** B2 invite dialog open. */
  invite?: boolean
  /** Inline seat purchase panel open. */
  buy?: 'seats'
  /** B3 member-detail drawer target (user_id). */
  member?: string
  /** B3 drawer inner tab. */
  tab?: string
}

/** B1 — Members roster (B2 invite + B3 drawer ride as search-param overlays). */
export const Route = createFileRoute('/_ws/w/$workspaceId/members')({
  validateSearch: (search: Record<string, unknown>): MembersSearch => ({
    invite: search.invite === true || search.invite === 'true' ? true : undefined,
    buy: search.buy === 'seats' ? 'seats' : undefined,
    member: typeof search.member === 'string' ? search.member : undefined,
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  component: MembersPage,
})
